module.exports = __webpack_public_path__ + "static/media/sidebar_settings_active.145b6176.svg";